"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_instantsearch_dom_1 = require("react-instantsearch-dom");
var react_1 = __importDefault(require("react"));
var util_1 = require("../util");
exports.default = react_instantsearch_dom_1.connectCurrentRefinements(function (_a) {
    var items = _a.items, refine = _a.refine;
    return (react_1.default.createElement("div", { className: "ais-CurrentRefinements" },
        react_1.default.createElement("ul", { className: "ais-CurrentRefinements-list" }, items.map(function (item) {
            if (item.items) {
                return (react_1.default.createElement("li", { key: item.label, className: "ais-CurrentRefinements-itemt" }, item.items && item.items.map(function (item) { return (react_1.default.createElement("span", { key: item.label, className: "ais-CurrentRefinements-category" },
                    react_1.default.createElement("span", { className: "ais-CurrentRefinements-categoryLabel" }, window.__(item.label.split(': ').pop() || '')),
                    react_1.default.createElement("button", { className: "ais-CurrentRefinements-delete", onClick: function (event) {
                            event.preventDefault();
                            refine(item.value);
                        } }, "\u2715"))); })));
            }
            if (item.label.includes('boundingBox')) {
                // @ts-ignore
                var label = util_1.$('#geo-search-input').value;
                return react_1.default.createElement("li", { key: item.label, className: "ais-CurrentRefinements-itemt" },
                    react_1.default.createElement("span", { className: "ais-CurrentRefinements-category" },
                        react_1.default.createElement("span", { className: "ais-CurrentRefinements-categoryLabel" }, label),
                        react_1.default.createElement("button", { className: "ais-CurrentRefinements-delete", onClick: function (event) {
                                event.preventDefault();
                                refine(item.value);
                                // @ts-ignore
                                util_1.$('#geo-search-input').value = '';
                            } }, "\u2715")));
            }
            return (react_1.default.createElement("li", { key: item.label, className: "ais-CurrentRefinements-itemt" },
                react_1.default.createElement("span", { className: "ais-CurrentRefinements-category" },
                    react_1.default.createElement("span", { className: "ais-CurrentRefinements-categoryLabel" }, window.__(item.label.split(': ').pop() || '')),
                    react_1.default.createElement("button", { className: "ais-CurrentRefinements-delete", onClick: function (event) {
                            event.preventDefault();
                            refine(item.value);
                        } }, "\u2715"))));
        }))));
});
